var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33334C4.32418 1.33334 1.3335 4.32403 1.3335 8.00001C1.3335 11.676 4.32418 14.6667 8.00016 14.6667C11.6761 14.6667 14.6668 11.676 14.6668 8.00001C14.6668 4.32403 11.6761 1.33334 8.00016 1.33334ZM8.00016 2.33334C11.1357 2.33334 13.6668 4.86447 13.6668 8.00001C13.6668 11.1355 11.1357 13.6667 8.00016 13.6667C4.86462 13.6667 2.3335 11.1355 2.3335 8.00001C2.3335 4.86447 4.86462 2.33334 8.00016 2.33334ZM7.49235 3.99285C7.35986 3.99492 7.2336 4.04949 7.14131 4.14459C7.04903 4.23968 6.99826 4.36751 7.00016 4.50001V8.16668C7.00019 8.29928 7.05288 8.42644 7.14665 8.52019L8.81331 10.1869C8.85939 10.2348 8.91457 10.2732 8.97563 10.2995C9.0367 10.3259 9.10241 10.3399 9.16893 10.3406C9.23545 10.3412 9.30144 10.3286 9.36303 10.3035C9.42462 10.2783 9.48057 10.2412 9.52761 10.1941C9.57465 10.1471 9.61183 10.0911 9.63697 10.0295C9.66211 9.96795 9.67472 9.90197 9.67404 9.83545C9.67337 9.76893 9.65942 9.70321 9.63303 9.64215C9.60664 9.58108 9.56833 9.5259 9.52034 9.47983L8.00016 7.95965V4.50001C8.00112 4.43309 7.98864 4.36665 7.96345 4.30465C7.93826 4.24264 7.90088 4.18632 7.85353 4.13902C7.80617 4.09173 7.7498 4.05442 7.68776 4.02931C7.62572 4.0042 7.55927 3.9918 7.49235 3.99285Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.2b93d5bb51ffab0eee2761bba86734ef.svg";
export { ForwardRef as ReactComponent };